module.exports = __webpack_public_path__ + "img/cricket-bat-ball.967c3a66.svg";